import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'projects/lib-shared-core/src/public-api';
import { environment } from 'projects/environments/environment';
import { SvcPrivateLayoutComponent } from '@solvace/feature/layout/private';

let routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'board' },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'board/main/posts' },
  { path: 'default.asp', pathMatch: 'full', redirectTo: 'board/main/posts' },
  {
    path: 'mcp-authorize',
    canActivate: [AuthGuard],
    loadComponent: () => import('./mcp-authorization/mcp-authorization.component').then((m) => m.McpAuthorizationComponent),
  },
  {
    path: 'board',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: SvcPrivateLayoutComponent,
    data: { layout: 'svc-workspace-layout' },
    loadChildren: () => import('./board/board.module').then((m) => m.BoardModule),
  },
  {
    path: 'praise-new',
    loadChildren: () => import(`@solvace/feature/modals/modal-praise-new/modal-praise-new-lazyload.module`).then((m) => m.ModalPraiseNewLazyloadModule),
  },
  {
    path: 'bos-new',
    loadChildren: () => import(`@solvace/feature/modals/svc-modal-bos/svc-modal-bos-lazyload.module`).then((m) => m.SvcModalBosLazyloadModule),
  },
  {
    path: 'alert-new',
    loadChildren: () => import(`@solvace/feature/modals/alert-record-modal`).then((m) => m.ALERT_RECORD_NEW_ROUTES),
  },
  {
    path: 'unsafecondition-new',
    loadChildren: () => import(`@solvace/feature/modals/svc-modal-unsafe-condition/svc-modal-unsafe-condition-lazyload.module`).then((m) => m.SvcModalUnsafeConditionLazyloadModule),
  },
  {
    path: 'rca-new',
    loadChildren: () => import(`@solvace/feature/modals/svc-modal-rca/svc-modal-rca-lazyload.module`).then((m) => m.SvcModalRcaLazyloadModule),
  },
  {
    path: 'defecttag-new',
    loadChildren: () => import(`@solvace/feature/modals/svc-modal-defect-tag/svc-modal-defect-tag-lazyload.module`).then((m) => m.SvcModalDefectTagLazyloadModule),
  },
  {
    path: 'action-plan-new',
    loadChildren: () => import(`@solvace/feature/modals/svc-modal-action-plan/svc-modal-action-plan-lazyload.module`).then((m) => m.SvcModalActionPlanLazyloadModule),
  },
  {
    path: 'cil-new',
    canActivate: [AuthGuard],
    loadChildren: () => import(`@solvace/feature/modals/svc-modal-cil-setup/svc-modal-cil-new-inspection-lazyload.module`).then((m) => m.SvcModalCilNewInspectionLazyloadModule),
  },
];

if (environment.isDEV || environment.isQA) {
  routes.push({
    path: 'table-example',
    component: SvcPrivateLayoutComponent,
    data: { layout: 'empty' },
    children: [
      {
        path: '',
        loadComponent: () => import('@solvace/component/svc-data-table/example/svc-data-table-example.component').then((m) => m.SvcDataTableExampleComponent),
      }
    ]
  });
  routes.push({
    path: 'accordion-example',
    component: SvcPrivateLayoutComponent,
    data: { layout: 'empty' },
    children: [
      {
        path: '',
        loadComponent: () => import('@solvace/component/svc-data-accordion/example/svc-data-accordion-example.component').then((m) => m.SvcDataAccordionxampleComponent),
      }
    ]
  });
}

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
